(function() {
    'use strict';

    angular.module('swif.openbase')
        .config(route)
        .controller('BanSitesController', BanSitesController)
        .controller('NewBanSitesController', NewBanSitesController)
        .controller('DuplicateSitesController', DuplicateSitesController)
        .controller('PendingSitesController', PendingSitesController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sites/ban_view', {
            templateUrl: 'partials/openbase/sites_ban_view.html',
            controller: BanSitesController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifOpenbaseSiteService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }

    function BanSitesController($scope, $q, swifOpenbaseService, swifFrameworkService, data) {
        'ngInject';

        var swif = swifFrameworkService;

        $scope.sites = data.sites;
        $scope.callback = swifOpenbaseService.site.callback;
        $scope.preValidate = swifOpenbaseService.site.preValidate;
        $scope.preModal = swifOpenbaseService.site.preModal;

        $scope.loading = {items: {}};
        $scope.refresh = refresh;

        // Sites count in the 3 tabs headers
        $scope.tabSitesCount = [];
        $scope.tabSitesCount['ban_sites'] = 0;
        $scope.tabSitesCount['ban_duplicate_sites'] = 0;
        $scope.tabSitesCount['ban_pending_sites'] = 0;

        function refresh() {
            swif.message.loading($scope.loading.items);
            var deferred = [];
            var collectionsIds = [
                'ban_sites',
                'ban_duplicate_sites',
                'ban_pending_sites'
            ];
            angular.forEach(collectionsIds, function(name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });
            $q.all(deferred).then(function(data) {
                angular.forEach(collectionsIds, function(name) {
                    $scope.tabSitesCount[name] = swif.collection.getCollection(name).currentCount;
                });
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        }

        /* Get synchronization date */
        swif.collections.createOrUpdate('ban_updated_date', 'ban_updated_date', {})
        .then(function(collection) {
            if (collection.items.length > 0) {
                $scope.updatedAt = moment(collection.items[collection.items.length-1].end_time).format('DD/MM/YYYY');
            } else {
                $scope.updatedAt = undefined;
            }
        });
    }

    function NewBanSitesController($scope, swifFrameworkService) {
        'ngInject';
        console.log('init NewBanSitesController');

        var swif = swifFrameworkService;

        /* Get BAN sites */
        var filter = {};
        swif.data.addFilter(filter, 'state', 'in', ["new", "completed"]);
        swif.data.sortOn(filter, 'create_date', 'DESC');
        swif.collection.createOrUpdate('ban_sites', 'ban_site', filter)
            .then(function(collection) {
                $scope.$parent.tabSitesCount['ban_sites'] = collection.currentCount;
                $scope.newSites = collection;
            });

        $scope.preModal = function(data) {
            if (data.action.id = "edit") {
                data.model.address = JSON.parse(data.model.data);
            }
        }

        $scope.preValidate = function(data) {
            data.model.data = JSON.stringify(data.model.address);
            return data;
        }

        $scope.callback = function(error, data) {
            $scope.newSites.fasterCallback(data);
            $scope.$parent.refresh();
        }

        $scope.updateTabCount = function(value) {
            $scope.$parent.tabSitesCount['ban_sites'] = value;
        }
    }

    function DuplicateSitesController($scope, swifFrameworkService) {
        'ngInject';
        console.log('init DuplicateSitesController');

        var swif = swifFrameworkService;

        var filter = {};
        swif.data.addFilter(filter, 'state', 'in', ["duplicate", "pending"]);
        swif.collection.createOrUpdate('ban_duplicate_sites', 'ban_site', filter)
            .then(function(collection) {
                $scope.$parent.tabSitesCount['ban_duplicate_sites'] = collection.currentCount;
                $scope.dupSites = collection;
            });

        $scope.callback = function(error, data) {
            $scope.dupSites.fasterCallback(data);
            $scope.$parent.refresh();
        }

        $scope.preValidate = function(data) {
            function onSuccess () {
                return true;
            }

            var ret;
            switch (data.action.id) {
                case 'postpone':
                    ret = swif.data.callKw(
                        'ban_site',
                        'update_state',
                        [[data.model.id]],
                        {state: "postponed"}
                    ).then(onSuccess);
                    break;
                case 'validate':
                    ret = swif.data.callKw(
                        'ban_site',
                        'update_state',
                        [[data.model.id]],
                        {state: "updated", data: data.model.data}
                    ).then(onSuccess);
                    break;
                default:
                    ret = swif.collection.getCollection('ban_duplicate_sites').preValidate(data);
            }
            return ret;
        }

        $scope.updateTabCount = function(value) {
            $scope.$parent.tabSitesCount['ban_duplicate_sites'] = value;
        }
    }

    function PendingSitesController($scope, swifFrameworkService) {
        'ngInject';

        console.log('init PendingSitesController');

        var swif = swifFrameworkService;

        var filter = {};
        swif.data.addFilter(filter, 'state', 'in', ["postponed", "updated"]);
        swif.data.sortOn(filter, 'state', 'ASC');

        var getFilter = function (states) {
            var stateFilter = angular.copy(filter);
            swif.data.addFilter(stateFilter, 'state', 'in', states);
            return stateFilter;
        };

        var countPostponedSites = function() {
            swif.data.getContentRange('ban_site', getFilter(['postponed']), {
                count: true
            }).then(function(count) {
                $scope.$parent.tabSitesCount['ban_pending_sites'] = count;
            });
        }

        swif.collection.createOrUpdate('ban_pending_sites', 'ban_site', filter)
            .then(function(collection) {
                $scope.$parent.tabSitesCount['ban_pending_sites'] = collection.currentCount;
                $scope.pendingSites = collection;

                countPostponedSites();
            });

        $scope.callback = function(error, data) {
            $scope.pendingSites.fasterCallback(data);
            $scope.$parent.refresh();
        }

        $scope.preValidate = function(data) {
            function onSuccess () {
                return true;
            }

            var ret;
            switch (data.action.id) {
                case 'validate':
                    ret = swif.data.callKw(
                        'ban_site',
                        'update_state',
                        [[data.model.id]],
                        {state: "updated", data: data.model.data}
                    ).then(onSuccess);
                    break;
                default:
                    ret = swif.collection.getCollection('ban_duplicate_sites').preValidate(data);
            }
            return ret;
        }

        $scope.updateTabCount = function(value) {
            countPostponedSites();
        }
    }
})();
